// Enum for target item types that API uses
// https://github.com/Memrise/memrise/blob/139b874a5899/lib/memlib/content/enums.py#L4
export const API_TARGET_ITEM_TYPES = {
  WORD: 1, // Examples: "a glass", "汽车"
  CHAR: 2, // Examples: "人", "一", "辶"
  PHRASE: 3, // Examples: "that's a good question!", "how can I help you?"
  ALPHABET: 4, // Examples: "п", "ゆ", "ด"
} as const;
